import {login, exit} from '@/api/login'
import {userExit} from '@/api/userlogin'

// import { getToken, setToken, removeToken } from '@/utils/auth'
const user = {
    state: {
        name: '',
        roles: []
    },

    mutations: {
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        }
    },

    actions: {
        // 登录
        LoginByUsername({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    if (response.data.code == 200) {

                        sessionStorage.setItem('role', "admin");
                        sessionStorage.setItem('token', response.data.msg);

                        console.log(data.loginName)
                        var loginName = data.loginName;
                        commit('SET_NAME', loginName)

                        let redata = {
                            code: response.data.code,
                            msg: response.data.msg
                        }
                        resolve(redata)
                    } else {
                        let redata = {
                            code: response.data.code,
                            msg: response.data.msg
                        }
                        resolve(redata)
                    }

                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetUserInfo({commit}) {


            return new Promise((resolve, reject) => {
                const roles = sessionStorage.getItem('role')
                commit('SET_ROLES', roles);
                resolve(roles)
            })
        },
        // 登出
        LogOut({commit}) {
            return new Promise((resolve, reject) => {
                let role = sessionStorage.getItem('role')
                if (role == 'admin') {
                    exit().then(() => {
                        commit('SET_ROLES', [])
                        commit('SET_NAME', '')
                        sessionStorage.clear('role')

                        resolve(role)
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    userExit().then(() => {
                        commit('SET_ROLES', [])
                        commit('SET_NAME', '')
                        sessionStorage.clear('role')

                        resolve(role)
                    }).catch(error => {
                        reject(error)
                    })
                }

            })
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                resolve()
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js